"use strict";

var smoothscroll = require('smoothscroll-polyfill');

exports.onClientEntry = function () {
  smoothscroll.polyfill();
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-smoothscroll/gatsby-browser.js
// module id = 515
// module chunks = 231608221292675